export var removeSpaces=function removeSpaces(val){return val.replace(/ /g,"");};